import { FileSpreadsheet } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Navigate, NavLink, useParams } from 'react-router';
import { PageHeader } from '../../ui/components';
import { ReportScopePicker } from '../reports/ReportScope';
import { ReportProfilesTab } from './ReportProfilesTab';

const TABS = [{ key: 'report-profiles', icon: FileSpreadsheet }] as const;

/** Device configuration managed centrally: templates assigned to sites and devices, kept in line by Central. */
export function ConfigurationPage() {
  const { t } = useTranslation();
  const { tab = 'report-profiles' } = useParams();
  if (!TABS.some((x) => x.key === tab)) return <Navigate to="/configuration/report-profiles" replace />;
  return (
    <div className="page">
      <PageHeader title={t('configurationPage.title')} actions={<ReportScopePicker withProject={false} />} />
      <nav className="tabs" aria-label={t('configurationPage.title')}>
        {TABS.map((x) => (
          <NavLink key={x.key} to={`/configuration/${x.key}`}>
            <x.icon size={15} />
            {t(`configurationPage.tabs.${x.key}`)}
          </NavLink>
        ))}
      </nav>
      {tab === 'report-profiles' && <ReportProfilesTab />}
    </div>
  );
}
